import { gql } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { defaultTo } from 'lodash-es';
import type { BearbeiterQuery } from './__generated__/BearbeiterQuery';

export const useBearbeiterQuery = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const { data, loading } = useQuery<BearbeiterQuery>(gql`
    query Bearbeiter {
      bearbeiter {
        id
        vorname
        nachname
        email
        isDeleted
        isSelectable
      }
    }
  `, {
    onError: handleWithErrorNotification('Die Liste der Bearbeiter konnte nicht geladen werden.'),
  });

  return {
    data: defaultTo(data?.bearbeiter, []),
    loading,
  };
};
